<template>
  <el-dialog title="选择组织" :visible.sync="dialogVisible" width="50%" @close="handleClose">
    <el-tree ref="orgTree" :data="orgs" node-key="id" :props="defaultProps" show-checkbox highlight-current
      @check-change="handleCheckChange"></el-tree>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">{{ $t('common.cancel') }}</el-button>
      <el-button type="primary" @click="confirmSelection">{{ $t('common.confirm') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { listOrgTree } from '@/api/frame/orgApi'

export default {
  name: 'ChooseOrgTree',
  data() {
    return {
      dialogVisible: false,
      orgs: [],
      currentOrg: {},
      defaultProps: {
        children: 'children',
        label: 'text'
      }
    }
  },
  methods: {
    open() {
      this.dialogVisible = true
      this.loadOrgs()
    },
    async loadOrgs() {
      try {
        const res = await listOrgTree()
        this.orgs = [res.data]
      } catch (error) {
        console.error('加载组织树失败:', error)
      }
    },
    handleCheckChange(data, checked) {
      if (checked) {
        this.currentOrg = {
          orgId: data.id,
          allOrgName: data.text
        }
      }
    },
    confirmSelection() {
      if (!this.currentOrg.orgId) {
        this.$message.warning(this.$t('chooseOrgTree.selectOrgTip'))
        return
      }
      this.$emit('switchOrg', this.currentOrg)
      this.dialogVisible = false
    },
    handleClose() {
      this.currentOrg = {}
      this.$refs.orgTree.setCheckedKeys([])
    }
  }
}
</script>

<style scoped>
.el-tree {
  max-height: 400px;
  overflow-y: auto;
}
</style>